const HIDDEN = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const;

/** A polite live region for screen readers, invisible on screen. */
export function VisuallyHiddenStatus({ message }: { message: string }) {
  return (
    <div role="status" aria-live="polite" style={HIDDEN}>
      {message}
    </div>
  );
}
